export const hasPermission = (permissions, currentUserPermissions) => {
  if (!permissions.length) return true;
  return permissions.some((permission) => currentUserPermissions.includes(permission));
};
